import {debounce} from 'es-toolkit'

const preventDoubleClick = (handler: (...args: unknown[]) => void) =>
  debounce(handler, 500, {edges: ['leading']})

export default preventDoubleClick
